import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //商品核查跟进-列表
  followList: (data) => apiAxios('post', baseURL + '/follow.followList', data),
  //核查上架-生成入库码
  generateUpStorageEntryCode: (data) => apiAxios('post', baseURL + '/follow.generateUpStorageEntryCode', data),
  //核查-上架预览
  upPreview: (data) => apiAxios('post', baseURL + '/follow.upPreview', data),
  // 核查-批量移库明细预览
  batchMovePreview: (data) => apiAxios('post', baseURL + '/follow.batchMovePreview', data),
  // 核查-批量移库
  batchMove: (data) => apiAxios('post', baseURL + '/follow.batchMove', data),
  //商品核查跟进-修改单番商品备注
  updateOrderDetailRemark: (data) => apiAxios('post', baseURL + '/follow.updateOrderDetailRemark', data),
  //创建检品单
  testArticle: (data) => apiAxios('post', baseURL + '/inspect.store', data),
  //核查界面获取未提交检品的检品单列表
  unAllotList: (data) => apiAxios('post', baseURL + '/inspect.unAllotList', data),
  //添加商品到检品单
  addGoodsList: (data) => apiAxios('post', baseURL + '/inspect.storeDetail', data),
  //核查-上架提交
  submitUpStorage: (data) => apiAxios('post', baseURL + '/follow.upStorage', data),
  //检品单详情
  testArticleDetails: (data) => apiAxios('post', baseURL + '/inspect.detail', data),
  //从检品单移除
  removeTestArticleDetail: (data) => apiAxios('post', baseURL + '/inspect.removeDetail', data),
  //检品单废弃
  deleteTestArticle: (data) => apiAxios('post', baseURL + '/inspect.discard', data),
  //取消检品
  cancelTestArticle: (data) => apiAxios('post', baseURL + '/inspect.cancel', data),
  //检品单调配
  dispatchTestArticlePerson: (data) => apiAxios('post', baseURL + '/inspect.dispatchAdmin', data),
  //检品单拆分
  testArticleSplit: (data) => apiAxios('post', baseURL + '/inspect.split', data),
  //检品单提交
  submitInspect: (data) => apiAxios('post', baseURL + '/inspect.submitInspect', data),
  //通用.检品单列表
  inspectList: (data) => apiAxios('post', baseURL + '/inspect.inspectList', data),
  //修改检品单备注
  updateTestArticleRemark: (data) => apiAxios('post', baseURL + '/inspect.updateRemark', data),
  //不良品列表
  badList: (data) => apiAxios('post', baseURL + '/inspect.badList', data),
  //不良品列表-不良确认
  badConfirm: (data) => apiAxios('post', baseURL + '/inspect.badConfirm', data),
  //检品操作界面数据预览
  inspectPreviewDetail: (data) => apiAxios('post', baseURL + '/inspect.inspectPreview', data),
  //检品员-开始处理
  startInspect: (data) => apiAxios('post', baseURL + '/inspect.startInspect', data),
  //检品员-提交检品
  inspectSave: (data) => apiAxios('post', baseURL + '/inspect.inspectSave', data),
  //核查跟进-查看检品详情列表
  purchaseInspectDetail: (data) => apiAxios('post', baseURL + '/follow.purchaseInspectDetail', data),

}
